export class ArrayUtils {

  static last<T>(array: T[]): T | undefined {
    return array[array.length - 1];
  }
}
